<template>
	<div v-show="show">
		<vs-row v-if="capacityUpdatePermission">
			<div class="vx-col w-full mb-base">
				<CapacityForm :dataCapacity="capacityItem" :isEditActive="true" />
			</div>
		</vs-row>
		<not-permission v-else></not-permission>
	</div>
</template>
<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import CapacityForm from "./CapacityForm.vue";

export default {
	name: "UpdateCapacity",
	components: {
		NotPermission,
		CapacityForm,
	},
	data() {
		return {
			capacityItem: {},
			show: false,
		};
	},
	computed: {
		capacityUpdatePermission() {
			return this.$store.getters.checkPermission("CAPACITY_U");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
